import type { Module } from 'vuex';
import { LanguageGroup } from '@/types/LanguageGroup';
import {RootState} from "@/store";

export interface LanguageGroupsState {
  languageGroups: LanguageGroup[];
}

const languageGroupsModule: Module<LanguageGroupsState, RootState> = {
  namespaced: true,

  state: (): LanguageGroupsState => ({
    languageGroups: [],
  }),

  getters: {
    getById: (state) => (idLanguageGroup: number): LanguageGroup | undefined => {
      return state.languageGroups.find(languageGroup => languageGroup.idLanguageGroup === idLanguageGroup);
    },
  },

  mutations: {
    setLanguageGroups(
      state,
      payload: { languageGroups: Record<number, any> }
    ) {
      state.languageGroups = Object
        .values(payload.languageGroups)
        .map(raw => LanguageGroup.fromRaw(raw));
    },

    setLanguageGroupCreate(
      state,
      payload: {
        idLanguageGroup: number;
        name: string;
      }
    ) {
      const languageGroup = new LanguageGroup(
        payload.idLanguageGroup,
        payload.name,
        false,
      );
      state.languageGroups.push(languageGroup);
    },

    setLanguageGroupDelete(
      state,
      payload: { idLanguageGroup: number }
    ) {
      state.languageGroups = state.languageGroups.filter(
        languageGroup => languageGroup.idLanguageGroup !== payload.idLanguageGroup
      );
    },
  },

  actions: {
    wsSetLanguageGroups({ commit }, payload) {
      commit('setLanguageGroups', payload);
    },
    wsLanguageGroupCreate({ commit }, payload) {
      commit('setLanguageGroupCreate', payload);
    },
    wsLanguageGroupDelete({ commit }, payload) {
      commit('setLanguageGroupDelete', payload);
    },
  },
};

export default languageGroupsModule;
